export default __webpack_public_path__ + "static/media/moon.aaab8424.png";